// @flow
import { useQuery, type QueryResult } from 'react-query';
import { productSettings } from 'platform/api';

import queryClient from 'common/middleware/queryClient';

import { toApiProduct } from './utils';

type Result = {
    settings: $FixMe,
    metadata: $FixMe,
    version: number
};

type Params = {
    clientId: string,
    product: string
};

const useProductSettingsFormQuery = ({
    clientId,
    product
}: Params): QueryResult<Result> => {
    const queryKey = ['product', product, 'settings'];
    return useQuery({
        queryKey,
        queryFn: async () => {
            const {
                settings,
                version,
                presentationMetaData: metadata
            } = await productSettings.fetch({
                clientId,
                product: toApiProduct(product)
            });

            const oldValue = queryClient.getQueryData(queryKey);

            // Issue: BE has cache enabled for get apis which can result
            // in returning stale data if multiple time data is fetched
            // TEMP_FIX: use FE value in case FE has new value
            return oldValue && oldValue.version > version
                ? {
                      metadata,
                      settings: oldValue.settings,
                      version: oldValue.version
                  }
                : { metadata, settings, version };
        },
        refetchOnWindowFocus: false
    });
};

export default useProductSettingsFormQuery;
